export const getTimeAgo = (timestamp) => {
    const now = new Date();
    const postedDate = new Date(timestamp);
    const diffInMs = now - postedDate;
  
    const diffInSecs = Math.floor(diffInMs / 1000);
    const diffInMins = Math.floor(diffInSecs / 60);
    const diffInHours = Math.floor(diffInMins / 60);
    const diffInDays = Math.floor(diffInHours / 24);
  
    if (diffInDays > 0) {
      return diffInDays === 1
        ? "Posted: 1 day ago"
        : `Posted: ${diffInDays} days ago`;
    } else if (diffInHours > 0) {
      return diffInHours === 1
        ? "Posted: 1 hour ago"
        : `Posted: ${diffInHours} hours ago`;
    } else if (diffInMins > 0) {
      return diffInMins === 1
        ? "Posted: 1 minute ago"
        : `Posted: ${diffInMins} minutes ago`;
    } else {
      return "Posted: Just now";
    }
  };